// MyCourses.tsx
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './MyCourses.css';
import CourseCard from '@/Components/CourseCard/CourseCard';
import { useInstructorLearningsStore } from '@/stores/InstructorStore/InstructorLearningsStore';
import { LoadingSpinner, ErrorDisplay } from '@/Components/common';
import { PiBookOpenTextThin } from 'react-icons/pi';

const MyCourses: React.FC = () => {
  const navigate = useNavigate();

  const {
    myCourses,
    loadingMyCourses,
    errorMyCourses,
    fetchMyCourses,
  } = useInstructorLearningsStore();

  // Fetch data on mount
  useEffect(() => {
    fetchMyCourses();
  }, [fetchMyCourses]);

  // Loading state
  if (loadingMyCourses) {
    return (
      <LoadingSpinner
        fullScreen
        size="lg"
      />
    );
  }

  // Error state
  if (errorMyCourses) {
    return (
      <ErrorDisplay
        fullScreen
        title="Failed to Load My Courses"
        message={errorMyCourses}
        type="error"
        showRetry
        onRetry={fetchMyCourses}
      />
    );
  }

  // Empty state
  if (!myCourses || myCourses.length === 0) {
    return (
      <div className="my-courses-container">
        <div className="my-courses-header">
          <h1>My Courses</h1>
          <p>Courses created and published by you</p>
        </div>
        <div className="my-courses-empty-state">
          <PiBookOpenTextThin size={64} />
          <h3>No Published Courses Yet</h3>
          <p>You haven't created any published courses yet. Go to Course Management to create your first course!</p>
          <button className="my-courses-browse-btn" onClick={() => navigate('/trainer/course-management')}>
            Create Course
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="my-courses-container">
      <div className="my-courses-header">
        <h1>My Courses</h1>
        <p>Courses created and published by you</p>
      </div>
      <div className="my-courses-grid">
        {myCourses?.map((course) => (
          <CourseCard key={course.id} course={course} />
        ))}
      </div>
    </div>
  );
};

export default MyCourses;
